import Header from './header';

export default Header;
